module.exports = __webpack_public_path__ + "img/teacherpeople.086b69a5.png";